const formatApiPhoneNumberUtil = (phoneNumber?: string | null) => {
  if (!phoneNumber) {
    return '';
  }

  const mobileRegexp = /^(50|51|53|57|60|66|69|72|73|78|79|88)/;

  const isPrefix = phoneNumber.startsWith('+48');

  const cleanedPhoneNumber = phoneNumber.replace('+48', '').replace(/\D/g, '');

  let result = isPrefix ? '+48 ' : '';

  if (!mobileRegexp.test(cleanedPhoneNumber)) {
    result += cleanedPhoneNumber.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, `$1-$2-$3-$4`);
  } else {
    result += cleanedPhoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');
  }

  return result.replaceAll('-', '');
};

export default formatApiPhoneNumberUtil;
